import BaseUpdateRequest from '@/models/Shared/BaseUpdateRequest';

export default class CreateIndustryRequest extends BaseUpdateRequest {
    name = '';
}